import * as t from "io-ts";

export type RequestStatus =
  | null
  | "loading"
  | "success"
  | "successNothingToDo"
  | "error"
  | "partialError";

export const TemplateIdsToImportV = t.type({
  templateIds: t.array(t.number),
  headerIds: t.array(t.number),
  footerIds: t.array(t.number),
  popupIds: t.array(t.number),
  blockIds: t.array(t.number)
});

export type TemplateIdsToImport = t.TypeOf<typeof TemplateIdsToImportV>;

export type DataStatuses = {
  trashingTemplates: RequestStatus;
  globalSettings: RequestStatus;
  designPresets: RequestStatus;
  postsAndPages: RequestStatus;
  templates: RequestStatus;
  headers: RequestStatus;
  footers: RequestStatus;
  popups: RequestStatus;
  blocks: RequestStatus;
};
